
import React from 'react';
import { Polyline, Polygon, CircleMarker } from 'react-leaflet';
import type { DrawingToolType } from '../../hooks/useDrawingMode';

import { BRAND } from '../../constants/mapColors';
interface DrawingActiveLayerProps {
  points: [number, number][];
  toolType: DrawingToolType;
}

const DrawingActiveLayer: React.FC<DrawingActiveLayerProps> = ({ points, toolType }) => {
  if (points.length === 0) return null;

  const positions = points.map(([lat, lon]) => [lat, lon] as [number, number]);

  return (
    <>
      {/* Draw line connecting points */}
      {points.length >= 2 && toolType === 'line' && (
        <Polyline
          positions={positions}
          pathOptions={{
            color: BRAND,
            weight: 4,
            dashArray: '8, 6',
            opacity: 0.9,
          }}
        />
      )}

      {/* Draw polygon for areas */}
      {points.length >= 2 && toolType === 'area' && (
        <Polygon
          positions={positions}
          pathOptions={{
            color: BRAND,
            weight: 3,
            dashArray: '8, 6',
            fillColor: BRAND,
            fillOpacity: 0.1,
          }}
        />
      )}

      {/* Vertex markers */}
      {points.map(([lat, lon], i) => (
        <CircleMarker
          key={i}
          center={[lat, lon]}
          radius={i === points.length - 1 ? 7 : 5}
          pathOptions={{
            color: '#ffffff',
            weight: 2,
            fillColor: BRAND,
            fillOpacity: 1,
          }}
        />
      ))}
    </>
  );
};

export default DrawingActiveLayer;
